type JsonObject = Record<string, any>;

export const USER_TOKEN_KEY = 'tyak_token';
export const ADMIN_TOKEN_KEY = 'grs_admin_auth';

export const getUserToken = (): string | null => {
  try {
    const raw = localStorage.getItem(USER_TOKEN_KEY);
    return raw ? String(raw) : null;
  } catch {
    return null;
  }
};

/**
 * Admin token 存储可能是：
 * - 纯 token 字符串
 * - JSON 字符串：{"token":"..."}
 */
export const getAdminToken = (): string | null => {
  try {
    const raw = localStorage.getItem(ADMIN_TOKEN_KEY);
    if (!raw) return null;
    try {
      const parsed = JSON.parse(raw) as JsonObject;
      const token = parsed?.token;
      return token ? String(token) : String(raw);
    } catch {
      return String(raw);
    }
  } catch {
    return null;
  }
};

export const buildBearerAuthHeader = (token: string | null, opts?: { allowEmptyBearer?: boolean }) => {
  const allowEmptyBearer = opts?.allowEmptyBearer ?? false;

  if (!token) {
    return allowEmptyBearer ? { Authorization: 'Bearer ' } : {};
  }

  return { Authorization: `Bearer ${token}` };
};

export const buildJsonHeaders = (opts?: { token?: string | null; allowEmptyBearer?: boolean; extra?: Record<string, string> }) => {
  const token = opts?.token ?? null;
  const allowEmptyBearer = opts?.allowEmptyBearer ?? false;
  const extra = opts?.extra ?? {};

  return {
    'Content-Type': 'application/json',
    ...buildBearerAuthHeader(token, { allowEmptyBearer }),
    ...extra,
  };
};
